import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import type { AssetType, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { AssetTypeIcon } from "../Icons/AssetTypeIcon"

export interface AssetTypeGroupProps extends MenuGroupProps {
	assetTypes: Stored<AssetType>[]
	onSelectAssetType: (assetType: Stored<AssetType>) => void
}

export const AssetTypeGroup = memo<AssetTypeGroupProps>((props) => {
	const { ref, assetTypes, onSelectAssetType, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{assetTypes.map((assetType) => {
				return (
					<Menu.Item key={assetType.uuid} onSelect={() => onSelectAssetType(assetType)}>
						<AssetTypeIcon assetTypeId={assetType.uuid} inline />
						<Text className="truncate">{assetType.name}</Text>
					</Menu.Item>
				)
			})}
		</Menu.Group>
	)
})
AssetTypeGroup.displayName = "AssetTypeGroup"
